var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlurTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 62,
    viewBox: "0 0 43 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1617_78849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7607 34.1446C71.1948 36.7388 71.1948 43.1475 66.7607 45.7416L11.2053 78.2442C6.72677 80.8644 1.09494 77.6344 1.09494 72.4457L1.09495 7.4405C1.09495 2.25182 6.72677 -0.978132 11.2053 1.64202L66.7607 34.1446Z",
    fill: "#CDFEB0",
    fillOpacity: 0.11,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7607 34.1446C71.1948 36.7388 71.1948 43.1475 66.7607 45.7416L11.2053 78.2442C6.72677 80.8644 1.09494 77.6344 1.09494 72.4457L1.09495 7.4405C1.09495 2.25182 6.72677 -0.978132 11.2053 1.64202L66.7607 34.1446Z",
    fill: "url(#paint0_linear_1617_78849)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1617_78849",
    x: -6.96584,
    y: -7.34914,
    width: 85.1133,
    height: 94.5845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.03077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1617_78849"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.671795,
    dy: -0.671795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1617_78849",
    result: "effect2_dropShadow_1617_78849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1617_78849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_78849",
    x1: 44.4257,
    y1: 60.4329,
    x2: 9.15649,
    y2: 10.0483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FCA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurTriangle);
export default __webpack_public_path__ + "static/media/blur-triangle.f8c0e40610f602eecfe1c65e8de0dc20.svg";
export { ForwardRef as ReactComponent };